// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"406":"7ab54942","758":"7ab54942","860":"13b3671f"}[chunkId] + ".css";
};